import { call, put } from 'redux-saga/effects';

import {
  setDeleteStatusMessage,
  setIsUserQuestionsLoading,
  setUserCreatedQuestions,
  setUserQuestionsMessage,
} from '../actions/submitAQuestionActions';
import * as Services from '../services/submitAQuestionService';

export function* submitAQuestionSaga(action) {
  try {
    yield put(setIsUserQuestionsLoading(true));
    const response = yield call(Services.submitNewQuestion, action.question);
    yield put(setUserCreatedQuestions(response));
    yield put(
      setUserQuestionsMessage({
        type: 'success',
        message: 'Question submitted successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUserQuestionsMessage({
        type: 'error',
        message: error.response.data,
      }),
    );
  } finally {
    yield put(setIsUserQuestionsLoading(false));
  }
}

export function* editSubmitQuestionSaga(action) {
  try {
    yield put(setIsUserQuestionsLoading(true));
    const response = yield call(
      Services.editSubmitQuestion,
      action.question,
      action.questionId,
      action.timestamp,
    );
    yield put(setUserCreatedQuestions(response));
    yield put(
      setUserQuestionsMessage({
        type: 'success',
        message: 'Question edited successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUserQuestionsMessage({
        type: 'error',
        message: error.response.data,
      }),
    );
  } finally {
    yield put(setIsUserQuestionsLoading(false));
  }
}

export function* getUserSubmittedQuestionsSaga() {
  try {
    yield put(setIsUserQuestionsLoading(true));
    const response = yield call(Services.getUserSubmittedQuestions);
    yield put(setUserCreatedQuestions(response));
  } catch (error) {
  } finally {
    yield put(setIsUserQuestionsLoading(false));
  }
}

export function* deleteUserSubmittedQuestionSaga(action) {
  try {
    yield put(setIsUserQuestionsLoading(true));
    const response = yield call(
      Services.deleteUserSubmittedQuestion,
      action.questionId,
      action.timestamp,
    );
    yield put(
      setDeleteStatusMessage({
        type: 'success',
        message: 'Question successfully deleted!',
      }),
    );
    yield put(setUserCreatedQuestions(response));
  } catch (error) {
    yield put(
      setDeleteStatusMessage({
        type: 'error',
        message: error.response.data,
      }),
    );
  } finally {
    yield put(setIsUserQuestionsLoading(false));
  }
}
